var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading"
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _vm.showView
            ? _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _vm.singleReleaseVerifyView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BLReleaseReview"),
                            name: "singleReleaseVerifyView"
                          }
                        },
                        [
                          _c("single-release-verify-view", {
                            attrs: {
                              "tab-name": "singleReleaseVerifyView",
                              "tab-title": _vm.$t(
                                "CargoMsg.Cargo_BLReleaseReview"
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.singleReleaseView
                    ? _c(
                        "el-tab-pane",
                        {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BLControl"),
                            name: "singleReleaseView"
                          }
                        },
                        [
                          _c("single-release-view", {
                            attrs: {
                              "tab-name": "singleReleaseView",
                              "tab-title": _vm.$t("CargoMsg.Cargo_BLControl")
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_ReleaseHbl"),
                        name: "hblSingleReleaseVerifyBaseView"
                      }
                    },
                    [
                      _c("hbl-single-release-verify-base-view", {
                        attrs: {
                          "tab-name": "hblSingleReleaseVerifyBaseView",
                          "tab-title": _vm.$t("CargoMsg.Cargo_ReleaseHbl")
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }